import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSliders, faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import Report from "./Report";

const Body = ({ userMsg, mode, botMsg, loading, rational, count, numberOfStates, message }) => {


  const isPlainObject = (obj) => {
    return ( obj !== null && typeof obj === 'object' && Object.getPrototypeOf(obj) === Object.prototype
    );
  }

  const printRow = (data) => {
    if (Array.isArray(data))
      return printTable(data);
    if (!isPlainObject(data)) {
      const value = (data + "").includes("</html>") ? <div dangerouslySetInnerHTML={{__html: data}}/> : <div>{data}</div>;
      return value;
    }
    return <div>
      {Object.entries(data).map(([key, value]) => (
        <p key={key}>
          <strong>{key}:</strong> {value}
        </p>
      ))}
    </div>
  }

  const printTable = (data) => {
    if (Array.isArray(data[0])) {
      return <div>
        {data.map(elem=>printRow(elem))}
      </div>
    }
    const headers = isPlainObject(data[0]) ? Object.keys(data[0]).filter(e=>e && e!="Condição") : null;
    return <table>
        <thead>
          {headers && <tr>
            {headers.map((header) => (
              <th key={header} style={styles.th}>
                {!header || header == "*" ? "Resultado" : header}
              </th>
            ))}
          </tr>}
        </thead>
        <tbody>
          {data.map((row, index) => {
            return <tr key={index} style={styles.tr}>
              {headers && headers?.map((header) => (
                <td key={"row_"+header+"_"+index} style={styles.td}>
                  {Array.isArray(row) ? row.map(elem=><div>{elem}</div>) : printRow(row[header])}
                </td>
              ))}
              {!headers && <td key={"row_"+index} style={styles.td}>
                  {Array.isArray(row) ? row.map(elem=><div>{elem}</div>) : printRow(row)}
                </td>}
            </tr>
          })}
        </tbody>
      </table>
  }

  const dynamicTable = (data) => {
    if (!data || data.length === 0) {
      return botMsg ? <div className="response-section"><p>Não há dados para exibir.</p></div> : "";
    }
    if (!data || (Array.isArray(data) && data.length == 0))
      return <p>"Não foi encontrado nenhum registro!"</p>
    if (isPlainObject(data))
      data = [data];
    return (
      <div className="response-section">
        <h2>Dados brutos</h2>
        <p>Abaixo estão os dados brutos calculados pelo sistema.</p>
        {Array.isArray(data) && data.length == 0 && <p>"Nenhum registro foi encontrado!"</p>}
        {Array.isArray(data) && data.length > 0 && printTable(data)}
        {!Array.isArray(data) && printRow(data)}
      </div>
    );
  }

  const reasoning = (data) => {
    if (!data || data.length === 0) {
      return botMsg ? <div className="response-section"><p>Não há dados para exibir.</p></div> : "";
    }
    return (
      <div className="response-section">
        <h2>Racional de cálculo</h2>
        <p>Abaixo estão os passos que seguimos para te dar a resposta.</p>
        <div className="calculation-card">
          {Array.isArray(data) ? data.map((e, i)=>{
            return <div className={"step completed"}>
              <span style={{width: 20, height: 10, fontSize: "28pt", position: "relative", top: -22, left: -5}}>•</span> {e} 
            </div>
          }) : "Racional de cálculo não disponibilizado."}
        </div>
      </div>
    );
  }

  return <div className="content">
    <div className="container">
      {userMsg &&
        <div className="chat-message" style={{ justifyContent: 'flex-end' }}>
          <div className="message user"   dangerouslySetInnerHTML={{ __html: userMsg }}></div>
        </div>}

      {userMsg && botMsg && <>
        <div className="chat-message">
          <div className={"profile-avatar" + (loading ? " loading" : "")}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
              <circle cx="8" cy="8" r="8" />
            </svg>
          </div>
          <div className="message ai"  dangerouslySetInnerHTML={{ __html: botMsg }}>
          </div>
          <br/>
        </div>

        {loading && rational && <div className="calculation-card" title={Math.round(100 * count/numberOfStates) + "% completo"}>
          {rational.map((e, i)=>{
            var stt = "pending", node = Math.floor((count/numberOfStates) * rational.length);
            if (node > i) 
              stt = "completed";
            else if (i >= node && i < node + 1) 
              stt = "running";
            return <div className={"step " + stt}>
              <span style={{width: 20, height: 10, fontSize: "28pt", position: "relative", top: -22, left: -5}}>•</span> {e} 
            </div>
          })}
        </div>}
      </>}
    </div>
    {mode=="Report" && message?.["Relatório"] && <Report content={message["Relatório"]}/>}
    {mode=="Reasoning" && reasoning(message?.["Racional de cálculo"] ? message["Racional de cálculo"] : message["Racional de Cálculo"])}
    {mode=="Raw" && dynamicTable(message?.["Resultado"])}
    
  </div>;
};

const styles = {
  table: {
    width: "100%",
    borderCollapse: "collapse",
    marginTop: "20px",
  },
  th: {
    border: "1px solid #ddd",
    padding: "8px",
    textAlign: "left",
    backgroundColor: "#f2f2f2",
  },
  td: {
    border: "1px solid #ddd",
    padding: "8px",
  },
  tr: {
    "&:nth-child(even)": { backgroundColor: "#f9f9f9" },
  },
};

export default Body;